class channel {
  constructor(
    name = "NoChannel",
    web = "http://www.tdtchannels.com",
    logo = "https://i.pinimg.com/736x/7c/1c/a4/7c1ca448be31c489fb66214ea3ae6deb.jpg",
    category = "",
    options = {},
    epg = undefined,
    cors = false
  ) {
    this.name = name;
    this.web = web;
    this.logo = logo;
    this.category = category;
    this.options = options;
    this.epg = epg;
    this.cors = cors;
  }
}

export default channel;
